import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Live contact details.
export const CONTACT = {
  phoneDisplay: "+91 9393939043",
  phoneHref: "tel:+919393939043",
  whatsapp: "https://wa.me/919393939043",
  email: "info@evolveelite.in",
  city: "Ahmedabad, Gujarat, India",
  address: "Accolade - II, 411, Science City Rd, opp. Shell Petrol Pump, Hebatpur, Ahmedabad, Gujarat 380060",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("Accolade II, 411, Science City Rd, opp. Shell Petrol Pump, Hebatpur, Ahmedabad, Gujarat 380060"),
};

export const SERVICES = [
  "Loans & Funding",
  "Wealth Portfolio",
  "Insurance Solutions",
  "Credit Card Bill Swiping",
  "Digital Marketing",
  "IT Services",
  "Interior Design & Architecture",
  "Videography & Photography",
  "Event Management",
  "Destination Weddings",
  "Other",
];

export const formatApiError = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
};

// Pre-filled WhatsApp message so a new lead lands on the business number instantly.
export const whatsappLeadUrl = ({ name, phone, email, service, message, source }) => {
  const lines = [
    "New Lead Alert - Evolve Elite",
    `Name: ${name}`,
    `Phone: ${phone}`,
    email ? `Email: ${email}` : null,
    `Service: ${service}`,
    message ? `Message: ${message}` : null,
    source ? `Source: ${source}` : null,
  ].filter(Boolean);
  return `${CONTACT.whatsapp}?text=${encodeURIComponent(lines.join("\n"))}`;
};

export const submitLead = async (payload) => {
  const { data } = await axios.post(`${API}/leads`, payload, { withCredentials: true });
  return data;
};
